import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=0cf3d195&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=js&"
export * from "./analysis.vue?vue&type=script&lang=js&"
import style0 from "./analysis.vue?vue&type=style&index=0&id=0cf3d195&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf3d195",
  null
  
)

export default component.exports